import { useEffect, useState } from 'preact/compat'
import defaultTranslations from '../../../l10n/translations.json'
import translationsAdapter from '../helpers/translations'

window.tuiPaymentTranslations = {
  default: defaultTranslations,
}

export const useTranslations = () => {
  const [l10n, setI10n] = useState(translationsAdapter.getTranslator())

  useEffect(() => {
    if (!Object.keys(translationsAdapter.instance.translations).length) return

    setI10n(translationsAdapter.getTranslator())
  }, [translationsAdapter.instance])

  return l10n
}
